import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Trophy, ListChecks, History as HistoryIcon } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

const TABS = [
  { to: "/dashboard", label: "Home", Icon: LayoutDashboard },
  { to: "/top-5", label: "Top 5", Icon: Trophy },
  { to: "/picks", label: "Picks", Icon: ListChecks },
  { to: "/history", label: "History", Icon: HistoryIcon },
];

const HIDE_PREFIXES = ["/admin", "/auth", "/reset-password", "/install", "/legal", "/privacy", "/terms", "/responsible-gambling", "/billing-terms", "/refund-policy"];

export default function MobileBottomNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user) return null;
  if (pathname === "/" ) return null;
  if (HIDE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))) return null;

  return (
    <nav
      aria-label="Primary mobile navigation"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-border/60 bg-background/85 backdrop-blur-xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="grid grid-cols-4">
        {TABS.map(({ to, label, Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] font-medium tracking-wide transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                }`
              }
              aria-label={label}
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`grid place-items-center w-9 h-9 rounded-xl transition ${
                      isActive ? "bg-primary/15 ring-1 ring-primary/30 shadow-[0_0_18px_-6px_hsl(var(--primary)/0.6)]" : ""
                    }`}
                  >
                    <Icon className="w-[18px] h-[18px]" />
                  </span>
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
